<template>
  <div class="soundtrackTemplate">
    <div v-show="!addMusicDialogVisible" class="mask">
      <div class="musicContent" style="width: auto">
        <!-- 左侧 -->
        <music-library-left></music-library-left>
        <div class="rootContainer" style="width: 676px">
          <div class="musicHeader">
            <p
              class="soundtrack"
              v-text="timeBarType == 'bgm' ? '音乐库' : '音频库'"
            ></p>
            <p class="closeSoundtrack" @click="closeSoundtrackBtn()">
              <span class="icon-popup-close"></span>
            </p>
          </div>
          <!-- <div class="musicMain"> -->
          <div class="tabNav">
            <div class="tabs">
              <span
                v-if="timeBarType == 'bgm'"
                @click="tabClick(0)"
                :class="[tabIndexs == 0 ? 'tabActive' : '']"
                >正版乐库</span
              >
              <span
                @click="tabClick(1)"
                :class="[tabIndexs == 1 ? 'tabActive' : '']"
                >我的音频</span
              >
              <span
                :class="[tabIndexs == 2 ? 'tabActive' : '']"
                @click="tabClick(2)"
                >团队音频</span
              >
            </div>
            <div style="display: flex">
              <div v-show="tabIndexs == '0'">
                <div class="switchItem">
                  <div
                    @click="musicListState(false)"
                    :class="[musicState == true ? '' : 'sliderBar']"
                    class="sliderBarTitle"
                  >
                    所有
                  </div>
                  <div
                    @click="musicListState(true)"
                    :class="[musicState == false ? '' : 'sliderBar']"
                    class="sliderBarTitle"
                  >
                    收藏
                  </div>
                </div>
              </div>
              <div @keydown.stop v-show="tabIndexs == '0'">
                <el-input
                  size="small"
                  class="searchBar"
                  prefix-icon="el-icon-search"
                  v-model="searchKeyWord"
                  @input="searchValChange"
                  clearable
                >
                </el-input>
              </div>
              <div @keydown.stop v-show="categoryFolder.length > 0">
                <el-select
                  size="small"
                  class="searchFolderBar"
                  v-model="selectFolder"
                  @change="
                    tabIndexs == 1 ? refreshMyMusic() : refreshTeamMusic()
                  "
                >
                  <el-option value="default" label="默认文件夹"></el-option>
                  <el-option
                    v-for="l in categoryFolder"
                    :key="l.id"
                    :label="l.name"
                    :value="l.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-show="!musicState && tabIndexs == 0" id="top-bar-container">
            <div class="musicStyle" ref="musicStyleRef">
              <span class="title">分类:</span>
              <!-- <span @click="showMoreStyle" :class="moreStyle == true ? "el-icon-arrow-down" : "el-icon-arrow-up" ">
                {{ moreStyle == true ? "更多" : "收起" }}
              </span> -->
              <span class="music-style-item">
                <span
                  v-for="(i, ind) in categorys"
                  @click="CategoryHandle(i)"
                  :key="ind"
                  :id="i.id"
                  :class="[selectCategoryId == i.id ? 'activeStyle' : '']"
                  >{{ i.name }}</span
                >
              </span>
            </div>
            <div class="fixed-filter-container">
              <div class="fixedFilter">
                <span class="title">排序:</span>
                <span
                  @click="sortHandleCommand(item)"
                  v-for="(item, indes) in sortFlags"
                  :key="indes"
                  class="cu-po payStyle"
                  :class="[sortStyleVal == item.value ? 'activeStyle' : '']"
                >
                  {{ item.name }}</span
                >
              </div>
              <div class="fixedFilter">
                <span class="title">付费类型:</span>
                <span
                  class="cu-po payStyle"
                  :class="[
                    selectPayStyleVal == items.value ? 'activeStyle' : '',
                  ]"
                  @click="payHandleCommand(items)"
                  v-for="(items, j) in resourceLevelOptions"
                  :key="j"
                  >{{ items.name }}</span
                >
              </div>
            </div>
          </div>
          <div
            v-loading="loading"
            element-loading-text="拼命加载中"
            class="content-container"
            ref="contentcontainer"
            @scroll="handleScroll"
            v-show="tabIndexs == 0"
            :class="[
              musicer.currentMusic && loading == false
                ? 'content-containerBottm'
                : '',
            ]"
          >
            <!-- 正版音频 -->
            <ul class="content-list">
              <li
                v-for="(item, index) in this.musicState == false
                  ? contentList
                  : favoriteList"
                :key="index"
                :class="[itemActive == item.id ? 'item-active' : '']"
              >
                <div class="music-item" @click.stop="showPlayOperate(item)">
                  <div
                    class="music-item-play-btn iconfont"
                    :class="[
                      item === musicer.currentMusic && musicer.isPlay
                        ? 'iconzanting'
                        : 'iconyinlebofang',
                    ]"
                    @click.stop="musicSelectAndPlay(item)"
                  ></div>
                  <div class="music-item-left">
                    <div class="music-item-shell">
                      <div class="music-item-title">
                        <span>{{ item.title }}</span>
                      </div>
                      <div
                        class="favorites-btn cu-po iconfont"
                        @click.stop="favoriteItem(item)"
                        :class="[
                          item && item.favorites
                            ? 'already-favorites'
                            : 'favorites',
                        ]"
                      ></div>
                    </div>
                    <div class="musicTimer">
                      <p>
                        {{ formatTime(item.duration) }}
                      </p>
                    </div>
                  </div>
                  <div class="music-item-right">
                    <div class="music-item-logo">
                      <div v-show="item.companyIcon" class="company-logo">
                        <img :src="$handleAssetsUrl(item.companyIcon)" alt />
                        <div class="company-arrow-box">
                          <span>{{ item.company }}</span>
                        </div>
                      </div>
                      <div
                        v-show="item.isCommerical"
                        class="music-item-commerical-logo"
                      ></div>
                    </div>
                    <div
                      v-if="item.payType == 1 && !item.tt"
                      class="music-item-price"
                    >
                      <span class="price">￥{{ item.price }}</span>
                    </div>
                    <div
                      v-if="item.payType == 1 && item.tt"
                      class="music-item-price"
                    >
                      <img class="bought" />
                    </div>
                    <div v-if="item.payType == 4" class="music-item-price">
                      <img :class="getBadgeClassName(item.payType, IsOldUser ? 'commonVip' : 'enterpriseS')" />
                    </div>
                    <div v-if="item.payType == 6" class="music-item-price">
                      <img :class="getBadgeClassName(item.payType, 'companyVip')" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div
            v-loading="loading"
            element-loading-text="拼命加载中"
            ref="myMusicContainer"
            @scroll="myMusichandleScroll"
            :class="[musicer.currentMusic ? 'content-containerBottm' : '']"
            class="content-container"
            v-show="tabIndexs == 1"
          >
            <ul v-show="myMusicList.length > 0" class="content-list">
              <!-- 我的音频 -->
              <li
                v-for="(item, index) in myMusicList"
                :key="index"
                :class="[itemActive == item.id ? 'item-active' : '']"
              >
                <div class="music-item" @click.stop="showPlayOperate(item)">
                  <div
                    class="music-item-play-btn iconfont"
                    :class="[
                      item === musicer.currentMusic && musicer.isPlay
                        ? 'iconzanting'
                        : 'iconyinlebofang',
                    ]"
                    @click.stop="musicSelectAndPlay(item)"
                  ></div>
                  <div class="music-item-left">
                    <div class="music-item-shell">
                      <div class="music-item-title">
                        <span>{{ item.title }}</span>
                      </div>
                    </div>
                    <div class="musicTimer">
                      <p>
                        {{ formatDate(item.createTime) }}
                      </p>
                    </div>
                  </div>
                  <div class="music-item-right">
                    <div>
                      <span
                        class="cu-po"
                        v-show="tabIndexs == 1"
                        @click.stop="deleteMyMusic(item)"
                      >
                        <i class="deleteIcon iconfont iconshanchu"></i>
                      </span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="使用"
                        placement="bottom"
                      >
                        <div
                          @click.stop="selectDub(item)"
                          :class="[
                            selectDubId == item.id ? 'selectDubActive' : '',
                          ]"
                          class="use cu-po iconfont icon3911"
                        ></div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div
            v-loading="loading"
            element-loading-text="拼命加载中"
            class="content-container"
            ref="teamContainer"
            @scroll="teamHandleScroll"
            :class="[musicer.currentMusic ? 'content-containerBottm' : '']"
            v-show="tabIndexs == 2"
          >
            <ul v-show="teamMusicList.length > 0" class="content-list">
              <li
                v-for="(a, b) in teamMusicList"
                :key="b"
                :class="[itemActive == a.id ? 'item-active' : '']"
              >
                <div class="music-item" @click.stop="showPlayOperate(a)">
                  <div
                    class="music-item-play-btn iconfont"
                    :class="[
                      a === musicer.currentMusic && musicer.isPlay
                        ? 'iconzanting'
                        : 'iconyinlebofang',
                    ]"
                    @click.stop="musicSelectAndPlay(a)"
                  ></div>
                  <div class="music-item-left">
                    <div class="music-item-shell">
                      <div class="music-item-title">
                        <span>{{ a.title }}</span>
                      </div>
                    </div>
                    <div class="musicTimer">
                      <p>
                        {{ formatDate(a.createTime) }}
                      </p>
                    </div>
                  </div>
                  <div class="music-item-right">
                    <div>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="使用"
                        placement="bottom"
                      >
                        <div
                          @click.stop="selectDub(a)"
                          :class="[
                            selectDubId == a.id ? 'selectDubActive' : '',
                          ]"
                          class="use cu-po iconfont icon3911"
                        ></div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <noUpload
            :tabIndexs="tabIndexs"
            v-if="
              (favoriteList.length == 0 &&
                tabIndexs == 0 &&
                musicState == true) ||
              (myMusicList.length == 0 && tabIndexs == 1 && loading == false) ||
              (teamMusicList.length == 0 && tabIndexs == 2 && loading == false)
            "
          ></noUpload>
          <div class="music-operate-bar-container" v-if="musicer.currentMusic">
            <div class="music-operate-bar">
              <div
                class="play-btn music-item-play-btn iconfont"
                :class="[musicer.isPlay ? 'iconzanting' : 'iconyinlebofang']"
                @click="musicPlay"
              ></div>
              <div>
                <div style="display: flex; justify-content: space-between">
                  <span class="music-title">{{
                    musicer.currentMusic.title
                  }}</span>
                  <span class="music-time-msg">{{
                    formatTime(musicer.currentTime) +
                    " / " +
                    formatTime(musicer.currentMusic.duration)
                  }}</span>
                </div>
                <audio
                  ref="audio"
                  controls="controls"
                  :volume="
                    timeBarType == 'bgm' ? getMusicVolume : getDubbingVolume
                  "
                  style="display: none"
                  :src="$handleAssetsUrl(musicer.currentMusic.url)"
                  @loadedmetadata="getAudioLength"
                  @timeupdate="audioTimeUpdate"
                  @play="handPlay"
                  @pause="handPause"
                ></audio>
                <div class="music-play-slider">
                  <el-slider
                    :show-tooltip="false"
                    v-model="musicer.currentTime"
                    :max="musicer.currentMusic.duration"
                    @change="changeAudioTime"
                  ></el-slider>
                </div>
              </div>
            </div>
            <div style="height: 100%;display: flex;align-items: center;">
              <!-- <template v-if="IsOldUser">
                <div v-show="musicer.currentMusic.payType == 4" class="vipTips">
                  VIP
                </div>
                <div
                  v-show="musicer.currentMusic.payType == 6"
                  class="corporateVip"
                >
                  企业VIP
                </div>
              </template>
              <template v-else>
              </template> -->
              <materialPayTypeSubscript
                :item="{payType: musicer.currentMusic.payType}"
                :style="{
                  'position': 'static'
                }"
              ></materialPayTypeSubscript>
              <el-button
                :class="[
                  musicer.currentMusic.payType == 4 ? 'vipBackground' : '',
                  musicer.currentMusic.payType == 6
                    ? 'corporateVipBackground'
                    : '',
                ]"
                class="addMusicBtn"
                @click="addUseMusic(musicer)"
                type="primary"
                ><span
                  v-if="musicer.currentMusic.payType === 1"
                  class="price-msg"
                  >{{ "￥" + musicer.currentMusic.price + "元" }}</span
                >立刻使用</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="addMusicDialogVisible"
      width="450px"
      :modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      center
    >
      <div>
        声音文件太长,无法在此处完整插入,若确认添加,我们将自动为您缩短音频内容
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          class="dialog-button"
          @click="addMusicDialogVisible = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          class="dialog-button"
          type="primary"
          @click="confirmAdd()"
          >添加</el-button
        >
        <div class="noRemindDialog">
          <el-checkbox v-model="noRemind"></el-checkbox>之后不再提醒
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="delectDialogVisible"
      width="450px"
      :modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      center
    >
      <span>请确认是否删除您所选择的素材？</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          class="dialog-button"
          @click="delectDialogVisible = false"
          >取 消</el-button
        >
        <el-button
          v-show="tabIndexs == 1"
          size="small"
          class="dialog-button"
          type="danger"
          @click="deleteMyVideo_dialog()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import isEmptyResult from "@/components/emodal/templateLib/isEmptyResult";
import audioPlay from "@/components/emodal/templateLib/contents/audioPlay.vue";
import musicLibraryLeft from "./musicLibraryleft";
import noUpload from "./noUpload";
import vipBadge from '@/components/mixins/vipBadge';
import materialPayTypeSubscript from "@/components/common/materialPayTypeSubscript";

export default {
  mixins: [audioPlay, vipBadge],
  name: "addsoundtrack",
  props: {},
  data() {
    return {
      delectDialogVisible: false,
      addMusicDialogVisible: false,
      deleteMusic: {},
      useItem: {},
      type: 5,
      //条件筛选
      contentList: [], //素材列表
      myMusicList: [], //我的音频
      teamMusicList: [], //团队音频
      categoryFolder: [], //我的音频分类文件夹
      selectFolder: "default",
      sortFlags: [
        { name: "推荐", value: "", id: "recommend" },
        { name: "最新", value: "&orderBy=2", id: "newest" },
      ],
      priceFlags: [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        { name: "付费", value: "&payType=1" },
        { name: "会员专属", value: "&payType=4" },
        { name: "企业会员专属", value: "&payType=6" },
      ],
      commericalFlags: [
        { name: "全部", value: "" },
        { name: "商用", value: "&isCommerical=1" },
      ],
      musicState: false, //为收藏还是所有状态
      favoriteList: [], //收藏数组
      favoriteIndex: 1, //收藏
      tabIndexs: 0, //tab的显示index
      selectPayStyleVal: "", //显示选中的付费类型值
      sortStyleVal: "",//排序
      selectCategoryId: null,
      searchKeyWord: "", //搜索值
      uploadData: {},
      musicFileList: [], //上传音乐文件列表
      categorys: [{ id: null, name: "全部" }], //素材分类
      //当前选中音乐
      musicer: {
        currentMusic: undefined,
        isPlay: false,
        playProcessor: "0%",
        currentTime: 0, //当前播放时间
        duration: 0, //标记时间戳
      },
      selectDubId: "",
      pageIndex: 1, //我的全部音乐
      myPageIndex: 1, //我的音乐
      teamPageIndex: 1, //团队音频
      scrollTop: "",
      itemActive: "",
      noRemind: true,
      loading: false,
      moreStyle: true,
    };
  },
  components: {
    isEmptyResult,
    musicLibraryLeft,
    noUpload,
    materialPayTypeSubscript
  },
  computed: {
    ...mapGetters(['IsOldUser']),
    ...mapGetters({
      StyleArrayMsg: "StyleArrayMsg",
      TOOL: "TOOL",
      WorksProjectId: "WorksProjectId",
      timeBarType: "addSoundtrack/getTimeBarType",
      receiveData: "addSoundtrack/getReceiveData",
      getMusicVolume: "addSoundtrack/getMusicVolume",
      getDubbingVolume: "addSoundtrack/getDubbingVolume",
      getNoRemind: "addSoundtrack/getNoRemind",
    }),
    getProcessor() {
      return (this.musicer.currentTime / this.musicer.duration) * 100 + "%";
    },
    resourceLevelOptions () {
      if (this.IsOldUser) {
        return [
          { name: "全部", value: "" },
          { name: "免费", value: "&payType=0" },
          { name: "付费", value: "&payType=1" },
          { name: "会员专属", value: "&payType=4" },
          { name: "企业会员专属", value: "&payType=6" },
        ]
      }
      return [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        { name: "付费", value: "&payType=1" },
        { name: this.getOptionName(6), value: "&payType=6" },
        { name: this.getOptionName(4), value: "&payType=4" },
      ]
    },
  },
  created() {
    if (this.timeBarType == "bgm") {
      this.getCategorys(); //获取素材分类
      this.refreshContentList();
    } else {
      this.tabIndexs = 1;
      this.refreshMyMusic();
    }
  },
  watch: {},
  mounted() {
    this.$bus.on("collectPersonal_vue", ({ data } = {}) => {
      if (data === "audio") {
        this.tabIndexs = 1;
        this.refreshMyMusic();
      }
    });
    this.$bus.on("uploadFile.addUserItem", ({ type } = {}) => {
      if (type === "sound") {
        this.$message.success("上传成功");
        this.tabIndexs = 1;
        this.refreshMyMusic();
      }
    });
  },
  methods: {
    // showMoreStyle() {
    //   if (this.moreStyle == true) {
    //     this.$refs.musicStyleRef.style = "height:auto";
    //   } else {
    //     this.$refs.musicStyleRef.style = "height:30px";
    //   }
    //   this.moreStyle = !this.moreStyle;
    // },
    tabClick(index) {
      this.selectFolder = "default";
      this.categoryFolder = [];
      if (index == 0) {
        this.tabIndexs = index;
      } else if (index == 1) {
        this.tabIndexs = index;
        this.refreshMyMusic();
      } else if (index == 2) {
        this.refreshTeamMusic();
      }
    },
    // 获取团队音频
    teamMusic() {
      let url =
        "/api/user/account/family/material?fPage=36&sOfPage=36&type=5&pIndex=" +
        this.teamPageIndex;
      if (this.selectFolder !== "default") {
        url += "&category=" + this.selectFolder;
      }
      this.$http
        .get(url)
        .then((res) => {
          if (res.data.code == 200) {
            this.tabIndexs = 2;
            this.getCategoryFolder();
            if (this.teamMusicList.length == 0) {
              this.teamMusicList = res.data.data;
            } else {
              for (var i = 0; i < res.data.data.length; i++) {
                this.teamMusicList.push(res.data.data[i]);
              }
            }
          } else if (res.data.code == 412) {
            this.$message({
              showClose: true,
              message: "您还未加入任何团队",
            });
          }
        })
        .catch((error) => {
          return error;
        });
    },
    selectDub(item) {
      this.selectDubId = item.id;
      if (
        !this.musicer.currentMusic ||
        item.id != this.musicer.currentMusic.id
      ) {
        this.showPlayOperate(item);
      }
      setTimeout(() => {
        this.addUseMusic(this.musicer);
      }, 200);
    },
    refreshMyMusic() {
      this.myPageIndex = 1;
      this.myMusicList = [];
      this.getMyMusic();
    },
    refreshTeamMusic() {
      this.teamPageIndex = 1;
      this.teamMusicList = [];
      this.teamMusic();
    },
    // 获取我的音频
    getMyMusic() {
      this.loading = true;
      this.getCategoryFolder("1");
      let url =
        "/api/user/music?fPage=24&sOfPage=24&pIndex=" + this.myPageIndex;
      if (this.selectFolder !== "default") {
        url += "&category=" + this.selectFolder;
      }
      this.$http
        .get(url)
        .then((res) => {
          this.loading = false;
          if (!this.myMusicList) {
            this.myMusicList = res.data.data;
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              this.myMusicList.push(res.data.data[i]);
            }
          }
        })
        .catch((error) => {
          return null;
        });
    },
    // 获取排序
    sortHandleCommand(item) {
      this.sortStyleVal = item.value;
      this.refreshContentList();
    },
    // 分类筛选
    CategoryHandle(item) {
      this.selectCategoryId = item.id;
      this.refreshContentList();
    },
    // 付费类型
    payHandleCommand(item) {
      this.selectPayStyleVal = item.value;
      this.refreshContentList();
    },
    // 搜索值
    searchValChange(val) {
      this.refreshContentList();
    },
    // 弹框关闭按钮
    closeSoundtrackBtn() {
      if (this.musicer.isPlay) {
        this.$refs.audio.pause();
      }
      this.musicer.currentTime = 0;
      this.$store.commit("addSoundtrack/setSoundtrackState", { state: false });
    },
    onpageCloseed: function () {
      if (this.musicer.isPlay) {
        this.$refs.audio.pause();
      }
    },
    // 状态为收藏还是所有
    musicListState(type) {
      this.musicState = type;
      if (type == false) {
        this.refreshContentList();
      } else {
        this.favoriteList = [];
        this.favoriteIndex = 1;
        this.getFavoriteList();
      }
    },
    //获取分类信息
    async getCategorys() {
      let requestBody = {
        type: 5,
        // style: 79,
      };
      let response = await this.getCategorysData(requestBody);
      if (response) {
        this.categorys = [{ id: null, name: "全部" }].concat(response);
      }
    },
    // 获取音频文件夹分类
    getCategoryFolder(ourself) {
      let url = "/api/user/material/category?type=5";
      if (ourself == "1") {
        url += "&ourself=" + ourself;
      }
      return this.$http
        .get(url)
        .then((res) => {
          this.categoryFolder = res.data.data;
        })
        .catch((error) => {
          return null;
        });
    },
    // 获取音乐分类
    getCategorysData: function (requestBody) {
      let url = "/api/home/category";
      return this.$http
        .get(url, {
          params: requestBody,
        })
        .then((res) => {
          let data = [];
          for (const key in res.data.data) {
            data.push(res.data.data[key]);
          }
          data = data.sort(function (a, b) {
            return a.power - b.power;
          });
          return data;
        })
        .catch((error) => {
          return null;
        });
    },
    // 获取收藏列表
    getFavoriteList() {
      let url =
        "/api/user/favorites/type?type=5&fPage=24&sOfPage=24&pIndex=" +
        this.favoriteIndex;
      this.$http
        .get(url)
        .then((res) => {
          if (!this.favoriteList) {
            this.favoriteList = res.data.data;
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              this.favoriteList.push(res.data.data[i]);
            }
          }
        })
        .catch((res) => {});
    },
    //刷新素材列表数据
    refreshContentList: function () {
      this.tabIndexs = 0;
      this.pageIndex = 1;
      this.contentList = [];
      this.getContentList();
    },
    // 获取正版音乐库
    getContentList: function () {
      this.loading = true;
      let url =
        "/api/common/material?type=5&fPage=24&sOfPage=24&pIndex=" +
        this.pageIndex +
        "&draftId=" +
        window.location.hash.slice(2) +
        "&findAll=1";
      if (this.selectPayStyleVal != "") {
        url += this.selectPayStyleVal;
      }
      if (this.selectCategoryId) {
        const cate = this.categorys.find(v => v.id === this.selectCategoryId);
        const pair = [0, 0];
        if (cate && cate.isStory === 0) {
          pair[0] = cate.id;
        }
        if (cate && cate.isStory === 1) {
          pair[1] = cate.id
        }
        const urlValue = pair.join(',');
        url += "&category=" + urlValue;
      }
      if (this.sortStyleVal != "") {
        url += this.sortStyleVal;
      }
      if (this.searchKeyWord != "") {
        url += "&keyword=" + this.searchKeyWord;
      }
      this.$http
        .get(url)
        .then((res) => {
          this.loading = false;
          if (!this.contentList) {
            this.contentList = res.data.data;
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              this.contentList.push(res.data.data[i]);
            }
          }
        })
        .catch((res) => {});
    },
    // 调起播放操作
    showPlayOperate(item) {
      //调起播放操作
      this.itemActive = item.id;
      this.musicer = {
        currentMusic: item,
        isPlay: false,
        playProcessor: "0%",
        currentTime: 0, //当前播放时间
        duration: 0, //时长
      };
    },
    changeAudioTime: function (val) {
      //获取视频播放时间
      if (this.$refs.audio) {
        this.$refs.audio.currentTime = val;
      }
    },
    getAudioLength: function () {
      //获取视频的时长
      if (this.$refs.audio) {
        this.musicer.duration = this.$refs.audio.duration;
      }
    },
    handPlay: function () {
      this.musicer.isPlay = true;
    },
    handPause: function () {
      this.musicer.isPlay = false;
      if (this.$refs.audio.ended) {
        this.musicer.currentTime = 0;
      }
    },
    musicPlay: function () {
      if (!this.musicer.isPlay) {
        this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
      }
    },
    audioTimeUpdate: function () {
      let time = this.$refs.audio.currentTime;
      if (time - this.musicer.currentTime > 1) {
        this.musicer.currentTime = time;
      }
    },
    musicSelectAndPlay: function (item) {
      if (this.musicer.currentMusic != item) {
        if (this.musicer.isPlay) {
          this.$refs.audio.pause();
        }
        this.musicer = {
          currentMusic: item,
          isPlay: false,
          playProcessor: "0%",
          currentTime: 0, //当前播放时间
          duration: 0, //标记时间戳
        };
      }
      setTimeout(() => {
        this.musicPlay();
      }, 200);
    },
    favoriteItem: function (item) {
      let postBody = {
        type: 5,
        id: item.id,
      };
      if (item.favorites) {
        postBody.isCancel = 1;
      }
      this.$http.post("/api/user/favorites", postBody).then((res) => {
        if (res.data.code == 200) {
          if (item.favorites) {
            item.favorites = null;
            //类型为收藏时去除当前数据的数据,为所有时只取消收藏
            this.favoriteList = this.favoriteList.filter(
              (val) => val.id !== item.id
            );
            this.$message({
              message: "已取消收藏",
              duration: "1500",
            });
          } else {
            item.favorites = true;
            this.$message({
              message: "收藏成功",
              type: "success",
              duration: "1500",
            });
          }
        }
      });
    },
    deleteTeamMusic(item) {
      this.delectDialogVisible = true;
      this.deleteMusic = item;
    },
    async confirmAdd() {
      this.$store.commit("addSoundtrack/setNoRemind", this.noRemind);
      this.useItem.timeSlot = [this.receiveData.start, this.receiveData.end];
      await this.isReplace(this.useItem, this.receiveData.index);
      this.closeSoundtrackBtn();
    },
    addUseMusic: function (item) {
      let currentMusic = item.currentMusic;
      if (this.musicer.isPlay) {
        this.$refs.audio.pause();
      }
      currentMusic.cut = [0, currentMusic.duration]; //裁剪时间段
      if (
        currentMusic.duration >
        this.receiveData.end - this.receiveData.start
      ) {
        // 显示弹框
        this.useItem = currentMusic;
        if (this.getNoRemind == 'true') {
          this.confirmAdd();
        } else {
          this.addMusicDialogVisible = true;
        }
      } else {
        currentMusic.timeSlot = [
          this.receiveData.start,
          this.receiveData.start + currentMusic.duration,
        ];
        this.isReplace(currentMusic, this.receiveData.index);
        this.closeSoundtrackBtn();
      }
    },
    async isReplace(item, index) {
      if (this.timeBarType == "bgm") {
        if (this.receiveData.operation == "replace") {
          await this.replaceMusic(item, index);
        } else {
          this.addMusic_(item, index);
        }
      } else {
        if (this.receiveData.operation == "replace") {
          this.replaceDubbing(item, index);
        } else {
          this.addDubbing_(item, index);
        }
      }
    },
    replaceMusic(music, index) {
      let reData = {};
      let select = this.$store.getters["addSoundtrack/getSelectMusic"];
      for (let key in music) {
        reData[key] = select[key];
      }
      if (this.$store.getters["addSoundtrack/getPlayHandle"].musicLoop) {
        this.$modal.show("SubtitleMessageDialog", {
            view: "Common",
            textAlign:"left",
            cancelText: '取消循环',
            okText: '保留',
            msg: `是否为新替换的配乐保留循环效果？`,
            resultCallback: (value) => {
              switch (value.type) {
                case 'Ok':
                  music.timeSlot = [0, this.$store.getters["addSoundtrack/getTotalTime"]];
                  this.replaceAction({music,index,reData,type: 'Ok'});
                break;
                case 'Cancel':
                  this.$store.commit("addSoundtrack/setLoopSoundtrackStatus", false);
                  this.replaceAction({music,index,reData,type: 'Cancel'});
                break;
                default: break;
              }
            }
          });
      } else {
        this.replaceAction({music,index,reData,type: ''});
      }
    },
    replaceAction ({music,index,reData,type}) {
      this.$store.commit("addSoundtrack/updateMusic", {
        music: music,
        index: index,
      });
      this.$bus.emit("replace_current_music", {
        event: "replace",
      });
      this.$bus.emit("insert_subtitle_undo", {
        type: "replaceMusic",
        data: {
          index,
          data: music,
          reData,
          type
        },
      });
    },
    replaceDubbing(dubbing, index) {
      let reData = {};
      let select = this.$store.getters["addSoundtrack/getSelectDubbing"];
      for (let key in dubbing) {
        reData[key] = select[key];
      }
      reData = JSON.stringify(reData);
      this.$store.commit("addSoundtrack/updateDubbing", {
        dubbing: dubbing,
        index: index,
      });
      this.$bus.emit("replace_current_dubing", {
        event: "replace",
      });
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateDubbing",
        data: {
          index: index,
          data: JSON.stringify(dubbing),
          reData: reData,
        },
      });
    },
    addMusic_(music, index) {
      this.$store.commit("addSoundtrack/addMusic", {
        music: music,
        index: index,
      });
      this.$store.commit("addSoundtrack/setMusicIndex", index);
      this.$bus.emit("insert_subtitle_undo", {
        type: "addMusic",
        data: {
          index: index,
          data: JSON.stringify(music),
        },
      });
    },
    addDubbing_(dubbing, index) {
      this.$store.commit("addSoundtrack/addDubbing", {
        dubbing: dubbing,
        index: index,
      });
      this.$store.commit("addSoundtrack/setDubbingIndex", index);
      this.$bus.emit("insert_subtitle_undo", {
        type: "addDubbing",
        data: {
          index: index,
          data: JSON.stringify(dubbing),
        },
      });
    },
    deleteMyVideo_dialog() {
      let url = "/api/user/music/" + this.deleteMusic.id;
      this.$http.delete(url).then((res) => {
        this.myMusicList = this.myMusicList.filter(
          (val) => val.id !== this.deleteMusic.id
        );
        this.delectDialogVisible = false;
      });
    },
    // 删除我的音频
    deleteMyMusic(item) {
      this.delectDialogVisible = true;
      this.deleteMusic = item;
    },

    handleScroll(e) {
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.contentcontainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        if (this.musicState == false) {
          this.pageIndex++;
          this.getContentList();
        } else {
          this.favoriteIndex++;
          this.getFavoriteList();
        }
      }
    },
    myMusichandleScroll(e) {
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.myMusicContainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.myPageIndex++;
        this.getMyMusic();
      }
    },
    teamHandleScroll(e) {
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.teamContainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.teamPageIndex++;
        this.teamMusic();
      }
    },
  },
};
</script>
  <style lang="scss" scoped>
@import "./soundtrack.scss";
</style>




// WEBPACK FOOTER //
// src/components/subtitle/soundtrack/addSoundtrack.vue